import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpFromBracket } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import type { ShareModalProps } from '@components/modals/ShareModal';
import { ShareModalPlaylist, ShareModalRelease } from '@components/modals/ShareModal';
import { ModalContext, ModalType } from '@context/modal';
import { usePrefetchEmbed } from '@hooks/usePrefetchEmbed';
import { trackClickEvent } from '@lib/analytics';
import { DropdownMenuItem, MenuItemLabel } from '../GlobalDropdown';

export const ShareMenuItem = (props: ShareModalProps) => {
  const { openModal } = ModalContext.useContainer();

  usePrefetchEmbed({
    playlistId: 'playlist' in props && props.playlist.id,
    releaseId: 'releaseId' in props && props.releaseId,
  });
  return (
    <DropdownMenuItem
      onClick={() => {
        if ('releaseId' in props) {
          trackClickEvent({
            event: 'Share Modal Opened',
            properties: {
              associationId: props.releaseId,
              associationType: 'Release',
              sourceComponent: props.source,
            },
          });
          openModal(ModalType.SHARE, {
            body: <ShareModalRelease {...props} />,
          });
        } else {
          trackClickEvent({
            event: 'Share Modal Opened',
            properties: {
              associationId: props.playlist.id,
              associationType: 'Playlist',
              sourceComponent: props.source,
            },
          });
          openModal(ModalType.SHARE, {
            body: <ShareModalPlaylist {...props} />,
          });
        }
      }}
    >
      <FontAwesomeIcon icon={faArrowUpFromBracket} size="lg" />
      <MenuItemLabel>Share</MenuItemLabel>
    </DropdownMenuItem>
  );
};
